
import React, { useState, useEffect } from 'react';

import '../css/listOfFilesPopUp.css';
import SearchableDropdown from '../SearchableDropdown';

import Spinner from '../Spinner'; // Import the Spinner component

import {
  showCatalogSchemas, showCatalogSchemasTables, showCatalogSchemasTablesColumns,
  fetchSqliteListTables, fetchSqliteListColumns
} from '../authorization/FetchToken';

function CreateTablePopupComponent({ loadCatalogList, loadDatabaseList, setLoadDatabaseList, loadTableList,
  setLoadTableList, onRemoveTable, nodes, setNodes,edges,setEdges, selectedNodeId,
  droppedNodes, setDroppedNodes, node, onClose, schema, setSchema, table,
  setTable, chunk, setChunk, delimeter, setDelimeter, onValueSubmit,
  connectionType, schemaDropdownValue,
  catalogDropdownValue, loadTableListNotSqliteOptionsValues,
  loadTableListUpdatedValues, catalogDataList, schemaDataList, tableDataList,
  tableDropdownNotSqliteValue, schemaSqliteDropdownValue, tableDropdownSqliteValue }) {

  console.log(JSON.stringify(schemaSqliteDropdownValue) + "schemaSqliteDropdownValue");
  console.log(JSON.stringify(tableDropdownNotSqliteValue) + "tableDropdownNotSqliteValue");
  console.log(JSON.stringify(catalogDataList) + "catalogDataList");
  console.log(JSON.stringify(schemaDataList) + "schemaDataList");
  console.log(JSON.stringify(tableDataList) + "tableDataList");
  console.log(JSON.stringify(loadTableListUpdatedValues) + "loadTableListUpdatedValues");
  console.log(JSON.stringify(schemaDropdownValue) + "schemaDropdownValue");
  console.log(JSON.stringify(loadDatabaseList) + "loadDatabaseList");
  console.log(JSON.stringify(loadTableList) + "loadTableList");
  console.log(JSON.stringify(schema) + "schema");
  console.log(JSON.stringify(table) + "table");
  console.log(JSON.stringify(connectionType) + "connectionType");
  console.log(JSON.stringify(loadTableListNotSqliteOptionsValues) + "loadTableListNotSqliteOptionsValues");

  const [loadTableListChanges, setLoadTableListChanges] = useState();

  const handleRemoveTable = () => {
    // Call the onRemoveTable callback function
    var newNodes = []
    var newEdges = []
    var newDroppedNodes = []
    //console.log("onRemoveTable::1", nodes[0]["id"], selectedNodeId)
    if (onRemoveTable) {
      newNodes = nodes.filter((node) => node["id"] != selectedNodeId);
      newEdges = edges.filter((edge) => !edge["id"].includes(`-${selectedNodeId}`));
      //edataTable_1-
      for (let i = 0; i < droppedNodes.length; i++) {
        if (droppedNodes[i] === selectedNodeId) {
          droppedNodes.splice(i, 1);
          console.log("Remaining elements: " + droppedNodes);
        }
      }
      //newDroppedNodes = droppedNodes.filter(!selectedNodeId)
      console.log("onRemoveTable::2", newNodes, selectedNodeId, edges, newEdges, newDroppedNodes)
      onRemoveTable();
    }
    // Close the popup
    setNodes(newNodes)
    setEdges(newEdges)
    setDroppedNodes(droppedNodes)
    //onClose(nodes)
  };

  let tableInitialDataList = '';

  const loadDatabaseListOptions = loadDatabaseList.map(item => ({
    label: item,
    value: item,
  }));

  const loadTableListValues = loadTableList.map(item => ({
    label: item,
    value: item,
  }));

  console.log(JSON.stringify(loadTableListValues) + "loadTableListValues");

  if (tableDataList && tableDataList.length > 0) {
    tableInitialDataList = tableDataList.map(item => ({
      label: item[0],
      value: item[0],
    }));
  }

  console.log(JSON.stringify(tableInitialDataList) + "tableInitialDataList");

  const renderCatalogsOptions = () => {
    return loadCatalogList.map((catalog, index) => (
      <option key={index} value={catalog}>
        {catalog}
      </option>
    ));
  };

  const renderDatabaseOptions = () => {
    return schemaList.map((database, index) => (
      <option key={index} value={database}>
        {database}
      </option>
    ));
  };
  const renderTableOptions = () => {
    return tableList.map((schema, index) => (
      <option key={index} value={schema}>
        {schema}
      </option>
    ));
  };

  const dropDownFields = [
    // { value: '', label: 'Select a window function' },
    { value: 'append', label: 'Append' },
    { value: 'replace', label: 'Replace' },
    { value: 'fail', label: 'Fail' },


    // Add more window functions as needed
  ];

  const fileFormatType = [
    // { value: '', label: 'Select a window function' },
    { value: 'csv', label: 'csv' },
    { value: 'json', label: 'json' },
    { value: 'excel', label: 'excel' },
    { value: 'parquet', label: 'parquet' }
    // Add more window functions as needed
  ];


  const [loading, setLoading] = useState(false);
  const [schemaList, setSchemaList] = useState(loadDatabaseList);
  const [tableList, setTableList] = useState(loadTableListValues.length > 0 ? loadTableListValues[0].value : []);
  const [catalogList, setCatalogList] = useState([]);

  const [ifTableExists, setIfTableExists] = useState(dropDownFields[0].value);
  const [chunkSize, setChunkSize] = useState('');
  const [fileFormatTypeValue, setFileFormatTypeValue] = useState(fileFormatType[0].value);
  const [schemaSqliteDropdown, setSchemaSqliteDropdown] = useState(schemaSqliteDropdownValue && schemaSqliteDropdownValue !== undefined ? schemaSqliteDropdownValue : loadDatabaseListOptions);
  const [schemaDropdown, setSchemaDropdown] = useState(schemaDropdownValue && schemaDropdownValue !== undefined ? schemaDropdownValue : '');
  const [tableDropdown, setTableDropdown] = useState(tableDropdownSqliteValue && tableDropdownSqliteValue !== undefined ? tableDropdownSqliteValue : loadTableList && loadTableList.length > 0 ? loadTableList[0][0] : '');
  const [tableDropdownNotSqlite, setTableDropdownNotSqlite] = useState(tableDropdownNotSqliteValue && tableDropdownNotSqliteValue !== undefined ? tableDropdownNotSqliteValue : loadTableList.length > 0 ? loadTableList[0][0] : []);
  const [catalogDropdown, setCatalogDropdown] = useState(catalogDropdownValue && catalogDropdownValue !== '' ? catalogDropdownValue : loadCatalogList.length > 0 ? loadCatalogList[0] : []);
  const [isTableEmpty, setIsTableEmpty] = useState(false);
  const [loadTableListOptions, setLoadTableListOptions] = useState([]);
  const [loadTableListNotSqliteOptions, setLoadTableListNotSqliteOptions] = useState(loadTableListNotSqliteOptionsValues && loadTableListNotSqliteOptionsValues.length > 0 ? loadTableListNotSqliteOptionsValues : tableInitialDataList);


  useEffect(() => {
    setCatalogDropdown(catalogDropdown);
    // setSchemaSqliteDropdown(schemaSqliteDropdown);

    // setTableDropdown(tableDropdown);
    // setTableDropdownNotSqlite(tableDropdownNotSqlite);
    // setTableList(tableList);
    setLoadTableListOptions(loadTableListValues);
    if (connectionType !== 'SQLite') {
      // setSchemaDropdown(schemaDropdown);
      // const loadTableOptions = loadTableList.map(item => ({
      //   label: item[0],
      //   value: item[0],
      // }));
      // console.log(JSON.stringify(loadTableOptions) + "loadTableOptions");
      // setLoadTableListNotSqliteOptions(loadTableOptions);
      //   setLoadTableList(loadTableList);
    }

    //setLoadDatabaseList(loadDatabaseList);
    //  setSchema(schema);
    // setTable(table);
    //setFileFormatTypeValue(fileFormatTypeValue);
    //  setIfTableExists(ifTableExists);
    //  setChunkSize(chunkSize);
  }, [schema, tableList, fileFormatTypeValue, ifTableExists, chunkSize, loadTableList, loadTableListNotSqliteOptions]
  );
  const handleSubmit = () => {
    // Implement your logic here for handling the form submission
    // You can access schema, table, chunk, delimeter, and columnType values here
    let jsonCreateTableData = '';
    let isTableDropdownExists = false;
    console.log('Schema:', schema);
    console.log('schemaDropdown:', schemaDropdown);

    console.log('Table:', table);
    console.log('FileFormatType:', fileFormatTypeValue);
    console.log('Delimeter:', delimeter);
    console.log('Chunk:', chunkSize);
    console.log('ifTableExists:', ifTableExists);

    if (connectionType !== 'SQLite') {
      // console.log('ColumnType:', columnType);
      isTableDropdownExists = loadTableListNotSqliteOptions.some(
        option => option.value === tableDropdownNotSqlite
      );
      console.log(isTableDropdownExists + "isTableDropdownExists");
      jsonCreateTableData = `${catalogDropdown}.${schemaDropdown}.${tableDropdownNotSqlite}`;
      console.log(JSON.stringify(jsonCreateTableData));
      onValueSubmit(onClose, jsonCreateTableData, isTableDropdownExists,
        catalogDropdown, schemaDropdown, tableDropdownNotSqlite,
        fileFormatTypeValue, chunkSize,
        ifTableExists, loadTableListNotSqliteOptions,
        loadTableList, tableDropdownNotSqlite);

    } else {
      isTableDropdownExists = loadTableListOptions.some(
        option => option.value === tableDropdown
      );
      console.log(isTableDropdownExists + "isTableDropdownExists");

      jsonCreateTableData = `${tableDropdown}`;
      console.log(JSON.stringify(jsonCreateTableData));
      onValueSubmit(onClose, jsonCreateTableData, isTableDropdownExists,
        schemaSqliteDropdown, tableDropdown,
        fileFormatTypeValue, chunkSize,
        ifTableExists, loadTableListNotSqliteOptions);

    }
    // Close the popup
    onClose();
  };

  // useEffect(() => {

  //   fetchTableList();
  // });

  // const fetchTableList = async (value) => {

  //   if (connectionType !== 'SQLite') {
  //     const catalogSchemaName = `${catalogDropdown}.${schema[0]}`;

  //     const response = await showCatalogSchemasTables(catalogSchemaName);
  //     console.log(JSON.stringify(response) + "response");
  //     if (response && response.length > 0) {
  //       setTableDropdownNotSqlite(response[0][0]);

  //     const loadTableListOptions = loadTableList.map(item => ({
  //       label: item[0],
  //       value: item[0],
  //     }));
  //     console.log(JSON.stringify(loadTableListOptions) + "loadTableListOptions");
  //     setLoadTableListNotSqliteOptions(loadTableListOptions);
  //     // setTableDropdownNotSqlite(loadTableListOptions[0].value);

  //     //  setLoading(false);
  //   }
  // }

  // };

  const handleTableChange = async (value) => {
    setTableDropdown(value);
  };
  const handleTableNotSqliteChange = async (value) => {
    setTableDropdownNotSqlite(value);
  };
  const handleDBListSQLiteChange = async (value) => {
    setSchemaSqliteDropdown(value);
    if (loadDatabaseListOptions.some(item => item.value === value)) {

      let tableNames = [];
      let columnNames = [];
      if (connectionType == "SQLite") {
        tableNames = await fetchSqliteListTables(value);
        console.log(JSON.stringify(tableNames) + "tableNames");
        if (tableNames.length > 0) {
          //setTableList(tableNames);
          setLoadTableList(tableNames);
          const tableNameOptions = tableNames.map(item => ({
            label: item,
            value: item,
          }));
          setLoadTableListOptions(tableNameOptions);
          console.log(JSON.stringify(tableNameOptions) + "tableNameOptions");

          setIsTableEmpty(false);
        } else {
          setTableList(tableNames);
          setIsTableEmpty(true);
        }
      }

    } else {
      setIsTableEmpty(true);
    }

  };



  const handleDBListChange = async (event) => {
    const schema = event.target.value;
    setSchemaDropdown(schema);

    setLoading(true);
    if (loadDatabaseList.some(item => item[0] === schema)) {

      const catalogSchemaName = `${catalogDropdown}.${schema}`;

      const response = await showCatalogSchemasTables(catalogSchemaName);
      console.log(JSON.stringify(response) + "response");
      if (response && response.length > 0) {
        setTableDropdownNotSqlite(response[0][0]);
        //  setLoadTableList(response.map(table => table[0]));
        const loadTableListOptions = response.map(table => table[0]).map(item => ({
          label: item,
          value: item,
        }));
        console.log(JSON.stringify(loadTableListOptions) + "loadTableListOptions");
        setLoadTableListNotSqliteOptions(loadTableListOptions);
        const currentTableList = loadTableListOptions.map(item => item.value);
        console.log(JSON.stringify(currentTableList) + "currentTableList");
        //  setLoadTableList(currentTableList);
        console.log(JSON.stringify(loadTableList) + "loadTableList");
        setIsTableEmpty(false);
      } else {
        setTableList('');
        setIsTableEmpty(false);
      }
    } else {
      setIsTableEmpty(true);
    }
    setLoading(false);
  };


  const handleCatalogChange = async (event) => {
    const catalog = event.target.value;
    setCatalogDropdown(catalog);
    let response = null;
    setLoading(true);
    try {
      response = await showCatalogSchemas(catalog);
      console.log(JSON.stringify(response) + "response");
      console.log(response.map(schema => schema[0]) + "1");
      console.log(response.map(schema => schema) + "2");
      setSchemaList(response.map(schema => schema));
      setSchemaDropdown(response.map(schema => schema));
      setLoadDatabaseList(response.map(schema => schema));

      console.log(response.length + "response.length");
      if (response && response.length > 0) {
        setTableDropdownNotSqlite(response[0][0]);
        setLoadDatabaseList(response.map(schema => schema));
        const loadTableListOptions = response.map(table => table[0]).map(item => ({
          label: item,
          value: item,
        }));
        console.log(JSON.stringify(loadTableListOptions) + "loadTableListOptions");
        setLoadTableListNotSqliteOptions(loadTableListOptions);

      }
    } catch (error) {
      console.error('Error fetching dropdown options:', error);
    }
    console.log(JSON.stringify(response) + "list of schemas");
    // setCatalog(catalog);
    setLoading(false);
  };


  return (
    <div className="overlay">

      <div className="file-popup-datatable">
        {/* <div className="popup-header"> */}
        {loading && (
          <div className="overlay">
            <div className="loading-container">
              <Spinner />
              <p className="please-wait">Please wait...</p>
            </div>
          </div>
        )}


        <div className="input-container">
          <h1>Create Table</h1>
          <div className="form-group">
            <label htmlFor="dropdown">List of Catalogs </label>


            <select id="database" className="form-control"
              value={catalogDropdown}
              onChange={handleCatalogChange}
              disabled={connectionType === 'SQLite'}
            >
              {renderCatalogsOptions()}
            </select>
          </div>
          <div className="input-row">
            <label className="file-fields" htmlFor="schema">Database:</label>

            {connectionType === 'SQLite' ? (
              <SearchableDropdown
                options={loadDatabaseListOptions}
                label="label"
                id="value"
                value={schemaSqliteDropdown}
                selectedVal={schemaSqliteDropdown}
                handleChange={(event) => handleDBListSQLiteChange(event)}
              />
            ) : (
              <select
                id="schema"
                className="form-control"
                value={schemaDropdown}
                onChange={(event) => handleDBListChange(event)}
              >
                {renderDatabaseOptions()}

              </select>
            )}

          </div>
          <div className="input-row">
            <label className="file-fields" htmlFor="table">Table:</label>

            {isTableEmpty ? (
              <input
                className="file-fields-input"
                type="text"
                id="table"
                value={tableList}
                onChange={(e) => setTableList(e.target.value)}
              />
            ) : (


              connectionType === "SQLite" ? (
                <SearchableDropdown
                  options={loadTableListOptions}
                  label="label"
                  id="value"
                  value={tableDropdown}
                  selectedVal={tableDropdown}
                  handleChange={(event) => handleTableChange(event)}
                />
              ) : (
                /* Render the second searchable dropdown here when connectiontype is not SQLite */
                <SearchableDropdown
                  options={loadTableListNotSqliteOptions}
                  label="label"
                  id="value"
                  value={tableDropdownNotSqlite}
                  selectedVal={tableDropdownNotSqlite}
                  handleChange={(event) => handleTableNotSqliteChange(event)}
                />
              )
              // <select
              //   id="database"
              //   className="form-control"
              //   value={tableList}
              //   onChange={handleTableChange}
              // >
              //   {/* Options for the select dropdown */}
              //   {renderSchemasOptions()}
              // </select>
            )}
          </div>
          <div className="input-row">
            <label className="file-fields" htmlFor="chunk">FileFormatType : </label>

            <select
              id={`dropdown`}
              className="form-control"
              value={fileFormatTypeValue}

              onChange={(event) => setFileFormatTypeValue(event.target.value)}
            >
              {fileFormatType.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>

          </div>
          <div className="input-row">
            <label className="file-fields" htmlFor="chunk">Delimeter:</label>
            <input className="file-fields-input" type="text" id="delimeter" value={delimeter} onChange={(e) => setDelimeter(e.target.value)} />
          </div>
          <div className="input-row">
            <label className="file-fields" htmlFor="chunk">Chunk Size:</label>
            <input className="file-fields-input" type="text" id="chunk" value={chunkSize} onChange={(e) => setChunkSize(e.target.value)} />
          </div>
          <div className="input-row">
            <label className="file-fields" htmlFor="chunk">If Table exists : </label>

            <select
              id={`dropdown`}
              className="form-control"
              value={ifTableExists}
              onChange={(event) => setIfTableExists(event.target.value)}
            >
              {dropDownFields.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>

          </div>

          <div>
            <textarea
              id="editor"
              rows="5"
              cols="50"
              value={''}
              placeholder="Change your columntype here"

            >

            </textarea>
          </div>
          <button type="button" onClick={handleSubmit}>SUBMIT</button>
          <button type="button" onClick={onClose}>CLOSE</button>
          <button type="button" onClick={handleRemoveTable}>Delete Tool</button>

        </div>

      </div>
      {/* </div> */}
    </div>
  );
}

export default CreateTablePopupComponent;
